import React from 'react';

import classes from 'components/widgets/LogicQualitySingleCheck/components/singleCheckConfigurationStatus/SingleCheckConfigurationStatus.module.scss';

interface Props {
    isIncludedInOverallScore: boolean | undefined;
    threshold: string | undefined;
}

export const SingleCheckConfigurationStatus = ({ isIncludedInOverallScore, threshold }: Props) => {
    return (
        <div className={classes.singleCheckConfigurationStatus}>
            <div className={classes.greenPill}>
                Included in overall score:
                <div className={classes.boldText}>{isIncludedInOverallScore ? 'Yes' : 'No'}</div>
            </div>
            <div className={classes.bluePill}>
                Target Threshold: <div className={classes.boldText}>{threshold ? threshold : ''}</div>
            </div>
        </div>
    );
};
